module.exports = __webpack_public_path__ + "img/ic_arrow_bottom.a627e7c0.svg";